import React, {Suspense, useEffect} from 'react';
import {Reset} from 'styled-reset';
import {injectStyle} from 'react-toastify/dist/inject-style';
import "react-datepicker/dist/react-datepicker.css";
import "./theme/custome-antd.css";
import ThemeProvider from "./theme";
import ErrorBoundary from "@/app/ErrorBoundary";
import {useRecoilState, useRecoilValue} from "recoil";
import {
    AccessModalStateSetter,
    isAccessModalState,
    loadingState,
    loginState,
    memberState,
    spaceNameState
} from "@services/stores/storeState";
import {useNavigate, useNavigationType, useSearchParams} from "react-router-dom";
import {RouteUrl} from "@app/constants/routeUrl";
import {KEYS} from "@app/constants/keys";
import EAlert from "@contents/applications/EAlert";
import {useLocation} from "react-router";
import BackgroundLoading from "@contents/components/BackgroundLoading";
import {ResponsibleContext} from "@services/stores/contextState";
import {AppViewModel} from "@contents/viewModels/appViewModel";
import Routes from "@/router";
import ToastComp from "@contents/applications/toast";
import ShopCopyProgressBar from "@contents/components/ShopCopyProgressBar";
import {FlexBox} from "@contents/components/customStyledComponent";
import AccessCertifyModalComp from "@contents/deskTop/layoutPages/components/modal/AccessCertifyModalComp";
import {resendAccessibleApi} from "@services/dataSource/lib/axiosInterceptor";

const App = () => {
    const navigate = useNavigate();
    const appViewModel = AppViewModel();
    const location = useLocation();
    const navType = useNavigationType();
    const spaceName = useRecoilValue(spaceNameState) || sessionStorage.getItem(KEYS.SPACE_NAME);
    const loginInfoState = useRecoilValue(loginState);
    const memberInfoState = useRecoilValue(memberState);
    const accessToken = sessionStorage.getItem(KEYS.AUTH_KEY);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useRecoilState(loadingState);
    const [accessModalState, setAccessModalState] = useRecoilState(isAccessModalState);

    console.log('route test', 'app.tsx');
    useEffect(() => {
        console.log(searchParams.toString());
        if(searchParams.get('code')) {
            navigate(RouteUrl.land.invite.url + '/' + searchParams.get('code') + '?' + searchParams.toString());
        } else {
            if (spaceName == null || spaceName.isEmpty()) {
                navigate(RouteUrl.auth.init.url);
                // navigate(RouteUrl.auth.init.url);
            } else if (loginInfoState.accessToken?.isEmpty() && (accessToken == null || accessToken == '')) {
                navigate(RouteUrl.auth.login.url);
            }
        }
        //
        // // 랜딩 페이지가 아닐때만 로직을 태운다.
        // if(!location.pathname.includes('land')) {
        //     if (spaceName == null || spaceName.isEmpty()) {
        //         navigate(RouteUrl.main.intro.url);
        //         // navigate(RouteUrl.auth.init.url);
        //     } else if (loginInfoState.accessToken?.isEmpty() && (accessToken == null || accessToken == '')) {
        //         navigate(RouteUrl.auth.login.url);
        //     }
        // }
    }, [])

    useEffect(() => {
        if(navType === 'POP' && isLoading){
            //로딩 걸렸을 시 뒤로가기 한 경우 > 로딩 해제
            setIsLoading(false);
        }
    }, [navType]);

    const onAccessCertifySuccess = () => {
        setAccessModalState(false);
        resendAccessibleApi();
    }

    injectStyle();

    return (
        <ThemeProvider>
            <Reset />
            <Suspense>
                <EAlert />
                <ToastComp/>
                <ResponsibleContext.Provider value={appViewModel}>
                    <FlexBox $column sx={{overflowY: 'hidden', height: '100%', position: 'relative'}}>
                        {
                            !appViewModel?.isMobile && (!loginInfoState.accessToken?.isEmpty() && memberInfoState?.baseRole === 'MASTER') &&
                            <ShopCopyProgressBar/>
                        }
                        <AccessModalStateSetter />
                        {
                            accessModalState && (<AccessCertifyModalComp open={accessModalState} handleClose={() => setAccessModalState(false)} handleSuccess={onAccessCertifySuccess}/>)
                        }
                        <ErrorBoundary>
                            <Routes />
                        </ErrorBoundary>
                    </FlexBox>
                </ResponsibleContext.Provider>
                <BackgroundLoading />
            </Suspense>
        </ThemeProvider>
    );
};

export default App;
